import React, { useMemo, useCallback, useState, useEffect } from 'react'
import { Spinner } from "reactstrap";
import Card from "../components/Card";
import { APIClient } from "../helpers/api_helper";
import {
    categoryAlias,
    categoryAliasId,
    categoryIdTranslations,
} from "../helpers/utils";
import { useTranslations } from 'next-intl'

const HomePageOffersComponent = ({ selectedType, selectedLang, favoriteIconRef }: { selectedType: any, selectedLang: any, favoriteIconRef: any }) => {
    const t = useTranslations("");
    const api = useMemo(() => new APIClient(), []);
    const headers = useMemo(() => ({ "Accept-Language": selectedLang }), [
        selectedLang,
    ]);

    const [homeInfo, setHomeInfo] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);

    const fetchHomeOffers = useCallback(async () => {
        try {
            setIsLoading(true);
            const response = await api.get("/site/home/info/", {}, headers);
            setHomeInfo(response);
        } catch (error) {
            console.error("Failed to fetch home offers:", error);
        } finally {
            setIsLoading(false);
        }
    }, [api, headers]);

    useEffect(() => {
        fetchHomeOffers();
    }, [fetchHomeOffers]);

    return (
        <>
            {
                Object.values(categoryAliasId).map((categoryId: any) => (
                    <div className="gray-background best-offers" key={categoryId}>
                        <section className="container-main">
                            <div className="section-title-container">
                                <i className="icon-apartment"></i>
                                <h2 className="section-title">{t(categoryIdTranslations[categoryId])}</h2>
                            </div>

                            {isLoading ? (
                                <div className='home_best_offers'>
                                    <Spinner className='me-2 text-center'> {t('Loading') + '...'} </Spinner>
                                </div>
                            ) : (
                                <div className="home_best_offers sellingBlock apartment_selling" id="apartment">
                                    {homeInfo?.[selectedType]?.[categoryId]?.map((item: any, index: number) => (
                                        <Card
                                            key={item.id+index}
                                            data={item}
                                            category={categoryAlias[categoryId]}
                                            favoriteIconRef={favoriteIconRef}
                                            selectedLang={selectedLang}
                                            withSlider={true}
                                        />
                                    ))}
                                </div>
                            )}
                        </section>
                    </div>
                ))
            }
        </>
    );
};

export default HomePageOffersComponent;
